export interface IdleState {
    lastActivityAt: number | null;
    isIdle: boolean;
}

export function createIdleState(): IdleState {
    return { lastActivityAt: null, isIdle: false };
}

export function recordActivity(state: IdleState, timestamp: number): void {
    state.lastActivityAt = timestamp;
    state.isIdle = false;
}

export function isIdleAt(
    state: IdleState,
    now: number,
    idleTimeoutMs: number
): boolean {
    if (state.lastActivityAt === null) {
        return false;
    }
    return now - state.lastActivityAt >= idleTimeoutMs;
}

export function updateIdleStateAt(
    state: IdleState,
    now: number,
    idleTimeoutMs: number
): boolean {
    state.isIdle = isIdleAt(state, now, idleTimeoutMs);
    return state.isIdle;
}

export function resetIdleState(state: IdleState): void {
    state.lastActivityAt = null;
    state.isIdle = false;
}
